import { AutogenLayoutBonusCodes } from "./autogen/AutogenLayoutBonusCodes";
import { DataSourceMode, TableRowDisplayEvent, Textbox, ValidationResult } from "@mcleod/components";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "bonus_code_hdr",
    screenName: "Bonus Code",
    navigateToUrl: "lme/settlement/BonusCodes?mode=update&key="
};

export class BonusCodes extends AutogenLayoutBonusCodes {
    async onLoad(): Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
        this.tablePayAdjustmentCodes.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            const modelRow = tableRow.data;
            const textboxDeductCodeId = tableRow.findComponentById("textboxDeductCodeId") as Textbox;
            if (textboxDeductCodeId) {
                textboxDeductCodeId.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult =>{
                    const result: ValidationResult = {
                        component: textboxDeductCodeId,
                        isValid: true
                    }
                    // check for duplicate deduct code id accross rows in table
                    for (const row of this.tablePayAdjustmentCodes.rows) {
                        if (row !== tableRow && row.data.get("deduct_code_id") === modelRow.get("deduct_code_id")) {
                            result.isValid = false;
                            result.validationMessage = "This pay adjustment code is already in use.";
                            break;
                        }
                    }
                    return result;
                }
            }
        });
    }
}
